import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BizbrainComponent } from "./bizbrain.component";
import { BizbrainWarningDialog } from "./bizbrain-warning-dialog";
import { share } from "rxjs";
import { SharedModule } from "@shared";

@NgModule({
  declarations: [
    // BizbrainWarningDialog
    // BizbrainComponent
  ],
  imports: [CommonModule, SharedModule],
})
export class BizbrainModule {}
